export default function shouldShowCombatLoaderMessage({
  showLoadingMessage = false,
  loadingMessage = '',
} = {}) {
  return Boolean(showLoadingMessage && loadingMessage)
}
